import { gsap } from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger.js';

gsap.registerPlugin(ScrollTrigger);

(function($) {
    const BREAKPOINT = 992;

    function moveLine($wrap, index) {
        const $line = $wrap.find('.tc-line-effect');
        const $container = $wrap.find('.tc-content-container');
        const $item = $wrap.find('.tc-content-slide').eq(index);
        if (!$line.length || !$container.length || !$item.length) {return;}

        const containerTop = $container.offset().top;
        const itemTop = $item.offset().top;
        const top = itemTop - containerTop;
        const height = $item.outerHeight();

        $line.stop(true,true).animate({ top, height }, 300); // smooth line animation
    }

    function initDesktopAccordion() {
        $('.tabbed-component').each(function() {
            const $wrap = $(this);
            const $items = $wrap.find('.tc-content-slide');
            const $buttons = $wrap.find('.tc-tab-link');
            const $images = $wrap.find('.img-row .tc-imgwrap');

            $buttons.off('click.tcAccordion');

            // Reset all slides
            $items.removeClass('active')
                .find('.tc-tab-left').hide()
                .end()
                .find('.tc-tab-link').show();

            // Reset images
            $images.removeClass('show reset-z');

            // Open first or already active slide
            let $activeItem = $items.filter('.active');
            if (!$activeItem.length) {$activeItem = $items.eq(0);}
            const index = $activeItem.index();

            $activeItem.addClass('active')
                .find('.tc-tab-left').show()
                .end()
                .find('.tc-tab-link').hide();

            $images.eq(index).addClass('show');

            setTimeout(() => moveLine($wrap, index), 50);

            // Click event
            $buttons.on('click.tcAccordion', function(e) {
                if (window.innerWidth < BREAKPOINT) {return;}
                e.preventDefault();

                const $current = $(this).closest('.tc-content-slide');
                const idx = $current.index();
                if ($current.hasClass('active')) {return;}

                // Close other slides smoothly
                $items.not($current).removeClass('active')
                    .find('.tc-tab-left').stop(true,true).slideUp(500)
                    .end()
                    .find('.tc-tab-link').stop(true,true).show();

                // Reset images
                $images.each(function(i){
                    if (i === idx) {return;}
                    if ($(this).hasClass('show')) {
                        $(this).addClass('reset-z');
                        setTimeout(() => $(this).removeClass('reset-z'), 1500);
                    }
                    $(this).removeClass('show');
                });

                // Open clicked slide
                $current.addClass('active');
                $current.find('.tc-tab-left').stop(true,true).slideDown(500, function(){
                    moveLine($wrap, idx);
                });
                $current.find('.tc-tab-link').hide();
                $images.eq(idx).addClass('show');
            });
        });
    }

    function destroyDesktopAccordion() {
        $('.tabbed-component').each(function() {
            const $wrap = $(this);
            const $items = $wrap.find('.tc-content-slide');
            const $images = $wrap.find('.img-row .tc-imgwrap');
            const $line = $wrap.find('.tc-line-effect');

            $items.removeClass('active')
                .find('.tc-tab-left').removeAttr('style')
                .end()
                .find('.tc-tab-link').show();
            $images.removeClass('show reset-z');
            $line.css({ top:'', height:'' });
        });
    }

    function setMobileActive($wrap, index) {
        const $items = $wrap.find('.tc-content-slide');
        const $images = $wrap.find('.img-row .tc-imgwrap');
        const $dropdownItems = $wrap.find('.tc-dropdown-item');
        const $mobileBtn = $wrap.find('.tc-mobile-dropdown-button');
        const $dropdownWrap = $wrap.find('.tc-dropdown-wrap');

        $items.each(function(i){
            const $left = $(this).find('.tc-tab-left');
            $(this).toggleClass('active', i===index);
            $left.toggle(i===index);
            $(this).find('.tc-tab-link').toggle(i!==index);
        });

        $images.each(function(i){
            if (i !== index && $(this).hasClass('show')) {
                $(this).addClass('reset-z');
                setTimeout(() => $(this).removeClass('reset-z'), 1500);
            }
            $(this).toggleClass('show', i===index);
        });

        $dropdownItems.removeClass('active');
        $dropdownItems.eq(index).addClass('active');
        $mobileBtn.find('.selected-title').text($dropdownItems.eq(index).text());

        $dropdownWrap.removeClass('open');
    }

    function handleTC() {
        if (window.innerWidth >= BREAKPOINT) {
            initDesktopAccordion();
        } else {
            destroyDesktopAccordion();
            $('.tabbed-component').each(function(){
                setMobileActive($(this),0);
            });
        }
    }

    // Mobile dropdown click
    $('.tabbed-component').each(function() {
        const $wrap = $(this);
        const $dropdownItems = $wrap.find('.tc-dropdown-item');
        const $mobileBtn = $wrap.find('.tc-mobile-dropdown-button');

        $dropdownItems.on('click', function(){
            const index = parseInt($(this).data('index'));
            setMobileActive($wrap,index);
        });

        $mobileBtn.on('click', function(){
            $wrap.find('.tc-dropdown-wrap').toggleClass('open');
        });
    });

    $(window).on('load resize', handleTC);

})(jQuery);
